var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { class: [_vm.listClass] },
      [
        _vm._t("errors", null, null, {
          items: _vm.items,
          filteredItems: _vm.filteredItems,
        }),
        _vm._v(" "),
        _vm._t("filter", null, null, {
          filters: _vm.filters,
          updateFilter: _vm.updateFilter,
          loadItems: _vm.loadItems,
          items: _vm.items,
          filteredItems: _vm.filteredItems,
        }),
        _vm._v(" "),
        _vm._t("banner"),
        _vm._v(" "),
        _vm._t("pagination", null, null, {
          pagination: _vm.pagination,
          defaultLimit: _vm.defaultLimit,
          allLoaded: _vm.allLoaded,
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "listWrapper",
            staticClass: "list-wrapper",
            style: [{ height: _vm.calculatedHeight }],
            attrs: {
              id: _vm.panelId,
              role: _vm.singlePanel ? null : "tabpanel",
              "data-component": "hotel-list-wrapper",
            },
          },
          [
            !_vm.isMounted ? _vm._t("default") : _vm._e(),
            _vm._v(" "),
            _vm._t("rendered-list", null, null, {
              items: _vm.items,
              filters: _vm.filters,
            }),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return [
                _vm._t("card-template", null, null, {
                  item: item,
                  key: JSON.stringify({ item: item, filters: _vm.filters }),
                }),
              ]
            }),
            _vm._v(" "),
            [_vm._t("uncontroled-slot", null, { filteredElements: _vm.items })],
            _vm._v(" "),
            _vm.items.length === 0 ? _vm._t("no-items") : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm._t("load-more", null, null, {
          pagination: _vm.pagination,
          defaultLimit: _vm.defaultLimit,
          allLoaded: _vm.allLoaded,
        }),
        _vm._v(" "),
        _vm._t("pagination", null, null, {
          pagination: _vm.pagination,
          defaultLimit: _vm.defaultLimit,
          allLoaded: _vm.allLoaded,
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }